import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { FaRegEdit } from "react-icons/fa";
import React from "react";
import RingSizeSelector from "./RingSizeSelector";
import ProductSet2 from "./ProductSet2";
import Quantity from "./Quantity";
import BraceletSizeSelector from "./BraceletSizeSelector";
import AnkletSizeSelector from "./AnkletSizeSelector";
import PetEngraving from './petEngraving';
import {
  AiOutlineShoppingCart,
} from "react-icons/ai";
import EngravingSection from "./EngravingSection";

const CartDrawer = (props) => {
  const {
    isOpen,
    onClose,
    isBuyNow,
    handleAddToCart,
    selectedProductDetails,
    qty,
    handleQuantityChange,
    selectedProduct,
    productSet,
    setProductSet,
    selectedPlating,
    sizes,
    loadingSize,
    errorSize,
    selectedSizeMen,
    setSelectedSizeMen,
    selectedSizeWomen,
    setSelectedSizeWomen,
    selectedAnkletSize,
    setSelectedAnkletSize,
    isPair,
    setIsPair,
    selectedBraceletSizeMen,
    setSelectedBraceletSizeMen,
    selectedBraceletSizeWomen,
    setSelectedBraceletSizeWomen,
    allowRingSize,
    setAllowRingSize,
    allowBraceletSize,
    setAllowBraceletSize,
    allowAnkletType,
    setAllowAnkletType,
    engravingTextMen,
    engravingTextWomen,
    handleEngravingInput,
    handleAccordionToggle,
    isAccordionOpen,
    selectedItems,
    setSelectedItems,
    selectedItemBasePrice,
    setSelectedItemBasePrice,
    totalPrice,
    totalBasePrice,
    engImage,
    petTypesSelected,
    frontPetTexts,
    backPetTexts,
    handlePetTypeChange,
    handlePetFrontEngChange,
    handlePetBackEngChange,
    breedAge,
    handleBreedAgeChange,
    breedSize,
    handleBreedSizeChange,
  } = props;

  const isRingCategory =
    allowRingSize ||
    selectedProduct?.products?.some((item) =>
      item.sku.toUpperCase().includes("SAIR")
    ) ||
    selectedProduct?.categories?.some((cat) => cat.name.toLowerCase() === "rings");

  const isAnkletCategory =
    allowAnkletType ||
    selectedProduct?.products?.some((item) =>
      item.sku.toUpperCase().includes("SAIA")
    ) ||
    selectedProduct?.categories?.some((cat) => cat.name === "ANKLETS");

  const isBraceletCategory =
    allowBraceletSize ||
    selectedProduct?.products?.some((item) =>
      item.sku.toUpperCase().includes("SAIB")
    ) ||
    selectedProduct?.categories?.some((cat) => cat.name === "BRACELETS");

  const isCoupleRing =
    selectedProduct?.categories?.some(
      (cat) =>
        ["rings", "bracelets", "pendants", "jewellery sets"].includes(
          cat.name.toLowerCase()
        )
    ) &&
    selectedProduct?.subcategories?.some(
      (cat) =>
        ["couple rings", "for couples"].includes(cat.name.toLowerCase())
    );

  const isPetProduct = selectedProduct?.productCollections?.some(cat => cat.name === "Pet Collection");
  const canBackEng = selectedProduct?.canBackEng;
  const canEngrave = selectedProduct?.canEngrave;
  const canImgEng = selectedProduct?.canImgEng;

  const showEngravingSection = () => {
    if (isCoupleRing) return true;
    if (!isPetProduct && canEngrave) return true;
    if (isPetProduct && canEngrave && !canBackEng) return true;
    return false;
  };

  const isSubmitDisabled = () => {
    if (productSet.length <= 1) {
      const isRingOrSet = selectedProduct?.categories?.some(cat => ["rings", "jewellery sets"].includes(cat.name.toLowerCase()));
      if (isRingOrSet) {
        return selectedProduct?.gender === "female"
          ? selectedSizeWomen === ""
          : selectedSizeMen === "";
      }

      if (isPetProduct && canImgEng) {
        return !engImage;
      }
    } else {
      if (allowRingSize) return selectedSizeWomen === "";
      return selectedItems.length === "" && !selectedBraceletSizeMen && !selectedBraceletSizeWomen;
    }
    return false;
  };

  return (
    <Drawer onClose={onClose} isOpen={isOpen} size="lg">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>Add Details</DrawerHeader>
        <DrawerBody>
          {/* <form onSubmit={(e) => handleAddToCart(selectedProductDetails)}> */}
          <div className="flex flex-col gap-6 mb-6">
            <Quantity qty={qty} handleQuantityChange={handleQuantityChange} />

            {/* Rings */}
            {isRingCategory && (
              <RingSizeSelector
                loadingSize={loadingSize}
                errorSize={errorSize}
                sizes={sizes}
                selectedProduct={selectedProduct}
                selectedSizeMen={selectedSizeMen}
                setSelectedSizeMen={setSelectedSizeMen}
                selectedSizeWomen={selectedSizeWomen}
                setSelectedSizeWomen={setSelectedSizeWomen}
              />
            )}

            {/* For Anklets */}
            {isAnkletCategory && (
              <AnkletSizeSelector
                value={selectedAnkletSize}
                onChange={(e) => setSelectedAnkletSize(e.target.value)}
                isPair={isPair}
                setIsPair={setIsPair}
              />
            )}

            {/* Bracelet Size */}
            {isBraceletCategory && (
              <BraceletSizeSelector
                selectedProduct={selectedProduct}
                selectedBraceletSizeMen={selectedBraceletSizeMen}
                setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
                selectedBraceletSizeWomen={selectedBraceletSizeWomen}
                setSelectedBraceletSizeWomen={setSelectedBraceletSizeWomen}
              />
            )}

            {/* Jewellery Sets */}
            {selectedProduct?.categories?.some(
              (cat) => cat.name == "JEWELLERY SETS"
            ) ? (
              <ProductSet2
                product={selectedProduct}
                variantId={
                  selectedProduct?.variants?.length > 0 &&
                  selectedProduct?.variants?.filter((variant) =>
                    selectedPlating.length > 0
                      ? selectedPlating.includes(variant.color)
                      : variant.isPrimary
                  )[0]?._id
                }
                productSet={productSet}
                setProductSet={setProductSet}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                selectedItemBasePrice={selectedItemBasePrice}
                setSelectedItemBasePrice={setSelectedItemBasePrice}
                totalPrice={totalPrice}
                totalbasePrice={totalBasePrice}
                allowRingSize={allowRingSize}
                setAllowRingSize={setAllowRingSize}
                allowBraceletSize={allowBraceletSize}
                setAllowBraceletSize={setAllowBraceletSize}
                allowAnkletType={allowAnkletType}
                setAllowAnkletType={setAllowAnkletType}
                isPair={isPair}
                setIsPair={setIsPair}
              />
            ) : null}


            <EngravingSection
              product={selectedProduct}
              engravingTextMen={engravingTextMen}
              engravingTextWomen={engravingTextWomen}
              allowRingSize={allowRingSize}
              productSet={productSet}
              isAccordionOpen={isAccordionOpen}
              handleAccordionToggle={handleAccordionToggle}
              handleEngravingInput={handleEngravingInput}
            />

            {isPetProduct && canEngrave && canBackEng &&
              [...Array(qty || 1)].map((_, index) => (

                <PetEngraving
                  key={index}
                  index={index}
                  product={selectedProduct}
                  selectedPetType={petTypesSelected[index]}
                  setSelectedPetType={(pet) => handlePetTypeChange(pet, index)}
                  frontPetText={frontPetTexts[index]}
                  handlePetFrontEngChange={(text) => handlePetFrontEngChange(text, index)}
                  backPetText={backPetTexts[index]}
                  handlePetBackEngChange={(text) => handlePetBackEngChange(text, index)}
                  breedAge={breedAge[index]}
                  handleBreedAgeChange={(text) => handleBreedAgeChange(text, index)}
                  breedSize={breedSize[index]}
                  handleBreedSizeChange={(text) => handleBreedSizeChange(text, index)}
                />
              ))}


          </div>

          <div className="w-1/2 group">
            <button
              className="flex rounded-3xl items-center justify-center w-full p-2 text-lg border rounded-md enbaled:cursor-pointer disabled:cursor-not-allowed bg-[#000080] border-[#000080] text-gray-100"

              onClick={(e) => {
                handleAddToCart(selectedProductDetails)
              }}
            >
              {isBuyNow ? (
                "BUY NOW"
              ) : (
                <>
                  Add to Cart
                  <AiOutlineShoppingCart className="ml-1 mb-1 animate-twice animate-jump animate-ease-in-out" />
                </>
              )}
            </button>
          </div>
          {/* </form> */}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default CartDrawer;
